// The leads of the IndexedDB reports the client files as issues (GitHub issue #3906). Shared with the
// server, which emails every crash issue except the ones that describe a handled condition: a dead
// connection the page is reloading for, and the recovery after that reload.
export const DeadStorageReloadLead = 'IndexedDB connection is dead and the page will reload';
export const StorageRecoveredAfterReloadLead = 'IndexedDB recovered after the page reloaded';

export const handledStorageReportLeads = [DeadStorageReloadLead, StorageRecoveredAfterReloadLead];
